import * as React from 'react';

export interface ToggleSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  value,
  onChange,
  disabled = false,
  size = 'md',
}) => {
  const sizeClasses = {
    sm: {
      button: 'h-5 w-9',
      thumb: 'h-3 w-3',
      translate: value ? 'translate-x-5' : 'translate-x-1',
    },
    md: {
      button: 'h-6 w-11',
      thumb: 'h-4 w-4',
      translate: value ? 'translate-x-6' : 'translate-x-1',
    },
  };

  const classes = sizeClasses[size];

  return (
    <button
      type='button'
      onClick={() => onChange(!value)}
      disabled={disabled}
      className={`relative inline-flex ${classes.button} flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${
        value ? 'bg-green-600' : 'bg-grey-200'
      }`}
    >
      <span
        className={`pointer-events-none inline-block ${classes.thumb} transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${classes.translate}`}
      />
    </button>
  );
};
